import { ErrorImage } from '../../../ErrorImage'

export function ErrorInvalidTokenImage() {
  return <ErrorImage src="/images/invalid-token-error.png" alt="Error-Invalid-Token" />
}
